<script setup lang="ts">
import { DynamicDialog, IftaLabel, Toast } from "primevue";
import { onErrorCaptured, onMounted } from "vue";
import { RouterView } from "vue-router";

onMounted(async () => {
    document.body.removeAttribute("v-cloak");
});

onErrorCaptured((e) => {
    console.error("Root: ", e);
});
</script>

<template>
    <RouterView />
    <DynamicDialog />
    <Toast>
        <template #message="toastProps">
            <div class="flex flex-col items-start flex-auto">
                <div class="flex items-center gap-2">
                    <span class="font-bold text-md">{{ toastProps.message.summary }}</span>
                </div>
                <div class="text-md">{{ toastProps.message.detail }}</div>
            </div>
        </template>
    </Toast>
    <Toast
        group="copy"
        position="bottom-center"
        :pt="{
            message: { class: 'rounded-full! flex justify-center' },
            content: { class: 'px-6 py-2' },
        }"
    >
        <template #message="slotProps">
            <div class="flex items-center gap-2">
                <span :class="['pi pi-info-circle', 'text-xl']"></span>
                <div class="flex-1">
                    <span class="font-bold block">{{ slotProps.message.summary }}</span>
                </div>
            </div>
        </template>
    </Toast>
    <IftaLabel />
</template>

<style>
.swal2-container {
    z-index: 99999 !important;
}

.swal2-popup {
    z-index: 99999 !important;
}

.p-accordionheader-toggle-icon {
    color: white !important;
    fill: white !important;
}

.ams-menu-item-highlight .p-accordionheader-toggle-icon {
    color: black !important;
    fill: black !important;
}
</style>
